import queryString from 'query-string';
import SourceType from '../helpers/SourceType';

export const shopPdpPath = (shopProductUrl, options = {}) => {
  const {
    categoryId,
    collection,
    outfitId,
    queryId,
    recommendedSkuId,
    referringOutfitId,
    referringSkuId,
    subSource,
    source,
  } = options;

  const collectionWithFallback = () => {
    if (source === SourceType.CATEGORIES) {
      // sometimes for categories, category_id is passed through as collection, which we cover with categoryIdWithFallback.
      // this just prevents us from sending both a collection + category_id query param
      // when they are the same value.
      return null;
    }
    if (source === SourceType.SYL) {
      return collection || 'kept-items';
    }

    return collection;
  };

  const categoryIdWithFallback = () => {
    if (source === SourceType.CATEGORIES) {
      return categoryId || collection;
    }

    return categoryId;
  };

  const params = {
    category_id: categoryIdWithFallback(),
    collection: collectionWithFallback(),
    outfit_id: outfitId,
    query_id: queryId,
    referring_outfit_id: referringOutfitId,
    referring_sku_id: referringSkuId,
    source,
    sub_source: subSource,
    'recommended-sku-id': recommendedSkuId, // Note: Using string key here because of dashes
  };

  const queryParams = queryString.stringify(params, {
    skipNull: true,
    skipEmptyString: true,
  });

  return !queryParams ? shopProductUrl : `${shopProductUrl}&${queryParams}`;
};

export const shopCategoriesPath = (categoryUrl, options = {}) => {
  const { queryId, source, subSource } = options;

  const params = {
    queryId,
    source,
    sub_source: subSource,
  };

  const queryParams = queryString.stringify(params, {
    skipNull: true,
    skipEmptyString: true,
  });

  return !queryParams ? categoryUrl : `${categoryUrl}?${queryParams}`;
};
